// Tap-to-move input: every press on the canvas is ONE discrete tap. main.ts
// maps the canvas pixel to world space and decides what was tapped (monster ->
// attack, player -> ignored, ground/gold -> move). There is deliberately no
// hold-to-move and no drag-steer — holding or dragging does nothing beyond the
// single tap fired on press.
//
// Right-click would pop a context menu, so it's suppressed.

type TapFn = (canvasX: number, canvasY: number) => void;

export class Input {
  private readonly canvas: HTMLCanvasElement;
  private readonly onTap: TapFn;

  constructor(canvas: HTMLCanvasElement, onTap: TapFn) {
    this.canvas = canvas;
    this.onTap = onTap;
  }

  attach(): void {
    this.canvas.addEventListener("pointerdown", this.onDown);
    this.canvas.addEventListener("contextmenu", this.onContextMenu);
  }

  private onDown = (e: PointerEvent): void => {
    const rect = this.canvas.getBoundingClientRect();
    this.onTap(e.clientX - rect.left, e.clientY - rect.top);
  };

  private onContextMenu = (e: MouseEvent): void => {
    e.preventDefault();
  };
}
